import * as headerBlock from '../header/';
import debounce from 'v-debounce';

const spinner = require('vue-strap').spinner;

export default {
  name: 'tasks',
  components: { headerBlock, spinner },
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  mounted() {

  },
  data() {
    return {
      formData: {
        tasks: [],
        filteredTask: [],
        taskFields: {
          index: {
            label: '#',
            tdClass: 'text-center',
            thClass: 'text-center',
          },
          id: {
            label: 'ID',
            tdClass: 'text-center',
            thClass: 'text-center',
          },
          name: {
            label: 'Text',
            tdClass: 'text-left',
            thClass: 'text-center',
          },
          area: {
            label: 'Working area',
            tdClass: 'text-left',
            thClass: 'text-center',
          },
          role: {
            label: 'Access',
            tdClass: 'text-left',
            thClass: 'text-center',
          },
          recurrence: {
            label: 'Recurrence',
            // tdClass: 'text-left',
            thClass: 'text-center',
          },
        },
      },
      currentPage: 1,
      perPage: 10,
      recurrenceFields: {
        area: {
          label: 'area',
        },
        recurrence: {
          label: 'recurr',
        },
      },
      areas: [],
      filter: '',
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Tasks',
          active: true,
        },
      ],
      roles: {
        basic: 'Basic user',
        shift_leader: 'Shift Leader',
        manager: 'Manager',
      },
      processLoading: false,
      processText: 'Loading...',
      dragSrcEl: null,
      dragBtn: false,
      mustDragToNextPage: true,
      shifts: [],
      weekdays: {
        weekday0: 'Sunday',
        weekday1: 'Monday',
        weekday2: 'Tuesday',
        weekday3: 'Wednesday',
        weekday4: 'Thursday',
        weekday5: 'Friday',
        weekday6: 'Saturday',
      },
      weekNumbersItem: [
        { text: 'First', value: 1 },
        { text: 'Second', value: 2 },
        { text: 'Third', value: 3 },
        { text: 'Fourth', value: 4 },
      ],
      weekDaysName: [
        { label: 'Monday', value: 2 },
        { label: 'Tuesday', value: 3 },
        { label: 'Wednesday', value: 4 },
        { label: 'Thursday', value: 5 },
        { label: 'Friday', value: 6 },
        { label: 'Saturday', value: 7 },
        { label: 'Sunday', value: 1 },
      ],

    };
  },
  methods: {
    getWeekNumbersItem(id) {
      for (let item in this.weekNumbersItem) {
        if (this.weekNumbersItem[item].value === id) return this.weekNumbersItem[item].text;
      }
      return '';
    },
    getDaysName(id) {
      for (const item in this.weekDaysName) {
        if (this.weekDaysName[item].value === id) return this.weekDaysName[item].label;
      }
      return '';
    },
    getShiftById(id) {
      for (let i = 0; i < this.shifts.length; i++) {
        if (this.shifts[i].id === id) {
          return this.shifts[i];
        }
      }
      return null;
    },
    getShiftTime(shift) {
      if (!shift) return '';
      const start = shift.start.split(':');
      const end = shift.end.split(':');
      const weekday = this.getDaysName(shift.day);
      return `${weekday} ${start[0]}:${start[1]}-${end[0]}:${end[1]}`;
    },
    isInFilter(item) {
      return JSON.stringify(item).toLowerCase().indexOf(this.filter.toLowerCase()) + 1 > 0;
    },
    filteredIndex(item) {
      return this.formData.filteredTask.indexOf(item);
    },
    getAddTaskUrl() {
      return `${process.env.START_URL}/constructor/TaskConstructor`;
    },
    onAddTaskClick() {
      console.log('onAddTaskClick');
      this.navigateTo("TaskConstructor", null);
    },
    onRowClick(item) {
      // alert(item);
      console.log('onclick', item);
      this.navigateTo("TaskConstructor", item.id);
      // this.$router.push(this.getAddTaskUrl());
      //this.$router.push({ name: 'Task Configuration Change', params: { taskId: item.id } });
    },
    navigateTo(pageName, taskId) {      
      var newUrl = window.location.href;

      var replacement = "/" + pageName;
      if(taskId) {
        replacement += "/" + taskId;
      }

      newUrl = newUrl.replace('/tasks', replacement);
      newUrl = newUrl.replace('/Tasks', replacement);
      
      var win = window.open(newUrl, '_blank');
      win.focus();
    },
    getTaskTemplatesList() {
      let url = 'task-templates/?type=task';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return null;
          }
          this.formData.tasks = response.body;
          this.formData.tasks.sort((a, b) => a.index - b.index);
          this.formData.filteredTask = this.formData.tasks;
          this.processLoading = false;
          return response.body;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return null;
          }
          this.areas = response.body;
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },

    // getRecurrence(self, task) {
    //   self.$http.get('task-templates/' + task.id + '/recurrencies/',
    //     {
    //       method: 'GET',
    //       headers: {
    //         Authorization: `Token ${this.access_token}`,
    //       },
    //       // emulateJSON: true,
    //     })
    //     .then((response) => {
    //       if (response.status !== 200) {
    //         console.log(response);
    //         return;
    //       }
    //       console.log('good recurrence', response);
    //       // task.recurrence = JSON.parse(JSON.stringify(response.body));
    //       task.recurrence = [{ area: 16, type: 'week' },{ area: 24, type: 'month' }];
    //       console.log('task ', task);
    //       // this.areas = response.body;
    //       // return response;
    //     });
    // },
    getWorkingAreasListById(id, areas) {
      let result = [];
      for (let i = 0; i < areas.length; i++) {
        if (areas[i].id == id) {
          result = [areas[i]];
          return result;
        }
        result = this.getWorkingAreasListById(id, areas[i].subareas);
        if (result.length) {
          result.unshift(areas[i]);
          return result;
        }
      }
      return result;
    },
    updateCompany() {
      this.processText = 'Loading...';
      let url = 'companies/';
      if (this.$route.params.companyId) {
        url = `${url}${this.$route.params.companyId}/`;
      } else {
        if (this.authUser.company.id) {
          url = `${url}${this.authUser.company.id}/`;
        } else {
          return;
        }
      }
      this.$http.get(url,
        {
          method: 'get',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return response;
          }
          if (response.body.manager_role_display_name) {
            this.roles.manager = response.body.manager_role_display_name;
          }
          if (response.body.shift_leader_role_display_name) {
            this.roles.shift_leader = response.body.shift_leader_role_display_name;
          }
          if (response.body.basic_role_display_name) {
            this.roles.basic = response.body.basic_role_display_name;
          }
          return null;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getShiftList() {
      let url = 'shifts/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            this.alertError.text = this.getErrorText(response);
            return;
          }
          this.shifts = response.body;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    handleBtnMouseEvent(flag) {
      this.dragBtn = flag;
    },
    handleDragStart(e, item, index) {
      if (!this.dragBtn) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        if (e.stopPropagation) {
          e.stopPropagation(); // Stops some browsers from redirecting.
        }
        return;
      }
      this.mustDragToNextPage = true;
      this.dragBtn = false;
      e.target.style.opacity = '0.4';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text', index.toString());
      this.dragSrcEl = index;
    },
    handleDragEnd(e, item, index) {
      e.target.style.opacity = '';
    },
    saveTaskIndex(task) {
      const data = { index: task.index };
      return this.$http.patch(`task-templates/${task.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return null;
          }
          return response.body;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          return response;
        });
    },
    updateTaskIndex() {
      for (let i = 0; i < this.formData.tasks.length; i++) {
        this.formData.tasks[i].index = +i + 1;
      }
      let savedTasksCount = 0;
      for (let i = 0; i < this.formData.tasks.length; i++) {
        this.processLoading = true;
        this.processText = 'Saving...';
        this.saveTaskIndex(this.formData.tasks[i])
        .then((response) => {
          savedTasksCount++;
          if (savedTasksCount === this.formData.tasks.length) {
            this.processLoading = false;
          }
        })
        .catch(() => {
          savedTasksCount++;
          if (savedTasksCount === this.formData.tasks.length) {
            this.processLoading = false;
          }
        });
      }
    },
    handleDrop(e, index) {
      console.log('handleDrop()', index);
      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }
      // Don't do anything if dropping the same column we're dragging.
      if (this.dragSrcEl !== index) {
        this.dragSrcEl = index;
        const newIndex = e.dataTransfer.getData('text');
        if (newIndex < this.dragSrcEl) {
          this.formData.tasks.splice(+this.dragSrcEl + 1, 0, this.formData.tasks[newIndex]);
          this.formData.tasks.splice(newIndex, 1);
        } else {
          this.formData.tasks.splice(+this.dragSrcEl, 0, this.formData.tasks[newIndex]);
          this.formData.tasks.splice(+newIndex + 1, 1);
        }
        this.activeTask = this.dragSrcEl;
        this.updateTaskIndex();
      }
      return false;
    },
    handleDragOver(e, index) {
      console.log('dragOver');
      this.mustDragToNextPage = true;
      if (e.preventDefault) {
        e.preventDefault();
      }
      // console.log('handleDragOver()', index);
    },
    handleDragEnter(e) { },
    changePage(isUp) {
      if (!this.mustDragToNextPage) {
        return null;
      }
      if (isUp) {
        if (this.currentPage > 1) {
          this.currentPage -= 1;
        }
      } else {
        if (this.currentPage < this.formData.tasks.length / this.perPage) {
          this.currentPage += 1;
        }
      }
      this.mustDragToNextPage = false;
      return null;
    },
  },
  computed: {
  },
  watch: {
    filter() {
      this.formData.filteredTask = this.formData.tasks.filter(this.isInFilter);
    },
  },
  created() {
    var self = this;
    this.processLoading = true;
    this.processText = 'Loading...';
    this.updateCompany();
    this.getShiftList();
    this.getTaskTemplatesList();
      // .then(function(response) {
      //   console.log('here');
        // if (!response) {
        //   return;
        // }
        // for (var i = 0; i < self.formData.tasks.length; i++) {
        //   console.log('need recurrence', self.formData.tasks[i].id);
        //   self.getRecurrence(self, self.formData.tasks[i]);
        // }
      // });
    this.getWorkingAreas();
  },
  directives: {
    debounce
  }
};



// WEBPACK FOOTER //
// ./src/components/tasks/tasks.component.js